import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    message: String,
    reload: Boolean,
    fallbackUrl: String
  }

  connect() {
    // Hand the success toast to the page we navigate back to, so it shows there
    // rather than on the form we're leaving (see shared/toast_controller.js).
    if (this.messageValue) {
      sessionStorage.setItem('pendingToast', this.messageValue)
    }

    // exempt page from cache so that it always loads fresh on return
    window.Turbo?.cache?.exemptPageFromCache()

    if (this.fallbackUrlValue && !this.hasPreviousPage()) {
      // Opened directly (bookmark, new tab): history.back() would leave the saved form on screen.
      this.visitFallback()
    } else if (this.reloadValue) {
      // history.back() restores a stale cached snapshot, so reload to show fresh
      // data. That back navigation renders into this *same* document, so flag it in
      // memory to suppress the toast there — only the reloaded page (a fresh window
      // without this flag) should surface it.
      window.pendingToastAwaitsReload = true

      history.back()

      const waitTimeBeforeRefreshPage = 200 // wait for the back navigation before refreshing
      setTimeout(() => window.location.reload(), waitTimeBeforeRefreshPage)
    } else {
      // No reload: the restored page is the final destination, so let it show now.
      history.back()
    }
  }

  // Turbo numbers the entries it pushes, starting from 0 on a full page load.
  hasPreviousPage() {
    return (history.state?.turbo?.restorationIndex ?? 0) > 0
  }

  visitFallback() {
    if (window.Turbo) {
      window.Turbo.visit(this.fallbackUrlValue, { action: 'replace' })
    } else {
      window.location.replace(this.fallbackUrlValue)
    }
  }
}
